'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Swiper, SwiperSlide } from 'swiper/react';

/** Карточка из конфига: S3-путь иконки */
export interface MainCardConfig {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
}

/** Карточка для рендера: данные AppImage (96x96), подготовленные на сервере */
export interface MainCard extends Omit<MainCardConfig, 'imageSrc'> {
  imageData: AppImageData;
}

interface Props {
  cards: MainCard[];
}

export const MainCardsSection = ({ cards }: Props) => {
  return (
    <>
      {/** Мобильная версия */}
      <div className="md:hidden">
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          className="ml-[-8px]! pr-14! pl-6!"
        >
          {cards.map((card) => (
            <SwiperSlide key={card.id}>
              <div className="bg-surface-base-secondary flex h-full flex-col justify-between gap-10 rounded-[20px] p-4 pb-6">
                <div className="flex h-[96px] w-[96px] items-center justify-center rounded-[20px]">
                  <AppImageClient {...card.imageData} alt={card.title} />
                </div>
                <div className="flex grow flex-col gap-3">
                  <h4 className="text-[20px] leading-[24px] font-medium tracking-[-0.1px]">
                    {card.title}
                  </h4>
                  <span className="text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
                    {card.description}
                  </span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/** Desktop версия */}
      <div className="m-auto grid max-w-[1208px] grid-cols-1 gap-8 px-4 max-sm:hidden md:grid-cols-3">
        {cards.map((card) => (
          <div
            key={card.id}
            className="bg-surface-base-secondary flex h-[360px] flex-col items-start justify-between rounded-[20px] p-7 pt-6"
          >
            <div className="flex h-[96px] w-[96px] items-center justify-center rounded-[20px]">
              <AppImageClient {...card.imageData} alt={card.title} />
            </div>
            <div className="flex flex-col gap-3">
              <h4 className="text-[24px] leading-[32px] font-medium tracking-[-0.12px]">
                {card.title}
              </h4>
              <span className="text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
                {card.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
